/** Дээд хязгааргүй шатлалыг "P" (тухайн дүнгээс дээш) гэж тэмдэглэж ирдэг */
export const OPEN_ENDED = 'P';

export const getWeight = (value) => {
  if (value === OPEN_ENDED) {
    return value;
  }
  if (value !== 0 && !value) {
    return '-';
  }
  return `${value}кг`;
};

export const getLength = (value) => {
  if (value !== 0 && !value) {
    return '-';
  }
  return `${value}см`;
};

export const getAmountWithThousandSeparators = (value, separator = ',') => {
  if (value !== 0 && !value) {
    return '-';
  }
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator);
};

/** Мөнгөн дүн: "P" (дээш) гэсэн тэмдэглэгээг хэвээр, эс бөгөөс ₮-тэй */
export const getPrice = (value) => {
  if (value === OPEN_ENDED) {
    return value;
  }
  if (value !== 0 && !value) {
    return '-';
  }
  return `${getAmountWithThousandSeparators(value)}₮`;
};

/**
 * Доод/дээд хязгаарыг нэг нүдэнд "0кг – 5кг" гэж уншуулна. Хоёр тусдаа багана
 * байснаас хүснэгт богиносож, шатлал нь нэг харцаар ойлгогдоно.
 */
const getRange = (format) => (from, to) => {
  if (to === OPEN_ENDED) {
    return `${format(from)}-аас дээш`;
  }
  return `${format(from)} – ${format(to)}`;
};

export const getWeightRange = getRange(getWeight);
export const getPriceRange = getRange(getPrice);

/** Төрөл + төлбөр гэсэн ижил бүтэцтэй үйлчилгээнүүдийн багана */
export const nameAndPriceColumns = [
  {
    key: 'name',
    title: 'Төрөл',
    render: (_, service) => service?.name || '-',
  },
  {
    key: 'price',
    title: 'Төлбөр',
    align: 'right',
    width: 160,
    render: (_, service) => getPrice(service?.price),
  },
];

export const getPercentOrPrice = (object) => {
  if (object.percent) {
    return `${object.percent}%`;
  }
  if (object.price) {
    return `${object.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}₮`;
  }
  return '-';
};
